var _style, _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 33",
    style: {
      enableBackground: "new 0 0 32 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000048474267488560444030000006492904496196119449_);}\n\t.st1{fill:#070101;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 32,
    height: 33
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066479019140322553970000013421344131375272625_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000066479019140322553970000013421344131375272625_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.4,15.6c4.2,0,7.6-3.4,7.6-7.6c0-4.2-3.4-7.6-7.6-7.6S16.8,3.8,16.8,8C16.8,12.2,20.2,15.6,24.4,15.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.2,0.4H2.9C1.3,0.4,0,1.7,0,3.4v9.3c0,1.6,1.3,3,2.9,3h9.3c1.6,0,2.9-1.3,2.9-3V3.4 C15.2,1.7,13.8,0.4,12.2,0.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.2,17.3H2.9c-1.6,0-2.9,1.3-2.9,3v9.3c0,1.6,1.3,3,2.9,3h9.3c1.6,0,2.9-1.3,2.9-3v-9.3 C15.2,18.6,13.8,17.3,12.2,17.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.1,17.3h-9.3c-1.6,0-2.9,1.3-2.9,3v9.3c0,1.6,1.3,3,2.9,3h9.3c1.6,0,2.9-1.3,2.9-3v-9.3 C32,18.6,30.7,17.3,29.1,17.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllLight);
export default __webpack_public_path__ + "static/media/all_light.2e3b34c360c24d1afae494c5a28773c6.svg";
export { ForwardRef as ReactComponent };